import { render } from "./ContactUsComponent.vue?vue&type=template&id=65103bf1&scoped=true&ts=true"
import script from "./ContactUsComponent.vue?vue&type=script&lang=ts"
export * from "./ContactUsComponent.vue?vue&type=script&lang=ts"

import "./ContactUsComponent.vue?vue&type=style&index=0&id=65103bf1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65103bf1"]])

export default __exports__